module.exports = __webpack_public_path__ + "static/espresso-z-cukrem-256bd4b05c5dbad850ac2f783ac3e747.png";